import { ToggleButton } from "react-bootstrap";

import { ServiceOrderType } from "../../../_constants/serviceOrder.ts";
import { businessServiceTypeLabels, servicesByBusinessType } from "../constants/index.ts";
import { useServiceInventoryStore } from "../store/ServiceInventoryStore";

const ServiceOrderingMenu = () => {
  const { 
    inventory, 
    erpExpress, 
    diagnostic, 
    currentForm, 
    setCurrentForm,
    businessServiceType 
  } = useServiceInventoryStore((state) => state);


  const serviceAddedHandler = (service: string): boolean => {
    switch (service) {
      case ServiceOrderType.ERP_EXPRESS:
        return !!erpExpress;
      case ServiceOrderType.DIAGNOSTIC:
        return !!diagnostic;
      default:
        return false;
    }
  };
  return (
    <div className="d-flex flex-column gap-3">
      {/* Service Options Based on Business Type */}
      {businessServiceType && servicesByBusinessType[businessServiceType] && (
        <div className="d-flex flex-column gap-2">
          <span className="serviceOrdering-subtitle">
            {businessServiceTypeLabels[businessServiceType] || "Services"}
          </span>
          <div className="d-flex gap-3 flex-wrap">
            {servicesByBusinessType[businessServiceType].map((service, index) => (
              <ToggleButton
                disabled={inventory ? inventory?.type !== service.value : false}
                key={index}
                id={`radio-service-${index}`}
                name="menu"
                value={service.value}
                variant={
                  (inventory?.type === service.value || serviceAddedHandler(service.value)) 
                    ? "success" 
                    : "outline-primary"
                }
                type="radio"
                checked={currentForm === service.value}
                onChange={(e) => setCurrentForm(e.currentTarget.value as ServiceOrderType)}
              >
                {service.label}
              </ToggleButton>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ServiceOrderingMenu;
